module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "overflow": "hidden !important"
    },
    attrs: {
      "grid-list-xl": "",
      "salesorderquotesettings": ""
    }
  }, [_c('v-form', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('h2', [_vm._v("Delivery signed and accepted by:")])]) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Name:")])]) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name",
      "solo": ""
    },
    model: {
      value: (_vm.metaData.name),
      callback: function($$v) {
        _vm.$set(_vm.metaData, "name", $$v)
      },
      expression: "metaData.name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg9": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Surname:")])]) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Surname",
      "solo": ""
    },
    model: {
      value: (_vm.metaData.surname),
      callback: function($$v) {
        _vm.$set(_vm.metaData, "surname", $$v)
      },
      expression: "metaData.surname"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg9": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("ID No:")])]) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ID No",
      "solo": ""
    },
    model: {
      value: (_vm.metaData.idNo),
      callback: function($$v) {
        _vm.$set(_vm.metaData, "idNo", $$v)
      },
      expression: "metaData.idNo"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg9": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Location:")])]) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Location",
      "solo": ""
    },
    model: {
      value: (_vm.metaData.location),
      callback: function($$v) {
        _vm.$set(_vm.metaData, "location", $$v)
      },
      expression: "metaData.location"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg9": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Employer:")])]) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Employer",
      "solo": ""
    },
    model: {
      value: (_vm.metaData.employer),
      callback: function($$v) {
        _vm.$set(_vm.metaData, "employer", $$v)
      },
      expression: "metaData.employer"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg9": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMeta == true) ? _c('v-flex', {
    attrs: {
      "lg9": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.fncSaveMeta
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncCancelMeta.apply(null, arguments)
      }
    }
  }, [_vm._v("Update Later")])], 1) : _vm._e(), _vm._v(" "), (_vm.globalModalParams && _vm.globalModalParams.quoteAttachments && _vm.globalModalParams.quoteAttachments.length > 0 && _vm.showMeta == false) ? _c('v-tabs', {
    attrs: {
      "slider-color": "grey"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Purchase Order Attachments")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Quote Attachments")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('input', {
    staticClass: "fileUpload",
    attrs: {
      "type": "file",
      "id": "quoteFile"
    },
    on: {
      "change": _vm.fncSetImageObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fileHolder"
  }, [_c('p', [_vm._v("Drag & Drop / "), _c('u', [_vm._v("Click to Add Files")])]), _vm._v(" "), _c('p', {
    staticClass: "filerules"
  }, [_vm._v("Maximum file size allowed:"), _c('b', [_vm._v(" " + _vm._s(_vm.objAuthorize.max_upload_size) + "MB")]), _c('br'), _vm._v("\n                File types supported:"), _c('b', [_vm._v(" " + _vm._s(_vm.objAuthorize.allowed_file_types))])]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.fileName))])]), _vm._v(" "), (_vm.objSoSettings.length == 0) ? _c('small', {
    staticClass: "pt-4 pb-4"
  }, [_vm._v("No attachments have been uploaded to this purchase order")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.objSoSettings.length != 0) ? _c('v-data-table', {
    staticClass: "elevation-1 ",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.objSoSettings,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncOpenFile(props.item.path)
            }
          }
        }, [_vm._v(_vm._s(props.item.original_filename))]), _vm._v(" "), (_vm.fncCanUpdatePod(props.item) && props.item.meta_data != null) ? _c('div', {
          staticStyle: {
            "margin-top": "10px",
            "text-indent": "5px"
          }
        }, [_c('b', [_vm._v("Delivery signed and Received by:")]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Name:")]), _vm._v(" " + _vm._s(JSON.parse(props.item.meta_data).name) + " " + _vm._s(JSON.parse(props.item.meta_data).surname))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("ID No:")]), _vm._v(" " + _vm._s(JSON.parse(props.item.meta_data).idNo))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Location:")]), _vm._v(" " + _vm._s(JSON.parse(props.item.meta_data).location))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Employer:")]), _vm._v(" " + _vm._s(JSON.parse(props.item.meta_data).employer))])]) : _vm._e()]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(_vm.fncFormatDate(props.item.created_timestamp)))]), _vm._v(" "), (_vm.attachmentCategories.length > 1) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "20%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          attrs: {
            "items": _vm.attachmentCategories,
            "label": "Attachment Category",
            "item-value": "id",
            "item-text": "name",
            "solo": "",
            "single-line": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncSaveAttachmentCategory(props.item.id, props.item)
            }
          },
          model: {
            value: (props.item.category),
            callback: function($$v) {
              _vm.$set(props.item, "category", $$v)
            },
            expression: "props.item.category"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "30%"
          }
        }, [_c('div', {
          staticStyle: {
            "margin-top": "10px",
            "font-size": "12px !important",
            "display": "flex",
            "justify-content": "space-between"
          }
        }, [(_vm.fncCanUpdatePod(props.item)) ? _c('v-btn', {
          style: (_vm.getStyle()),
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.fncShowMeta(props.item.id, props.item.meta_data)
            }
          }
        }, [_vm._v("UPDATE ORDER RECIPIENT DETAILS")]) : _vm._e(), _vm._v(" "), (_vm.fncCanUpdatePod(props.item) && _vm.globalModalParams && _vm.globalModalParams.fullQuote && _vm.globalModalParams.fullQuote.status !== 'POD Uploaded') ? _c('v-btn', {
          staticStyle: {
            "width": "48%"
          },
          attrs: {
            "color": "info"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.fncCheckPodStatus())
          },
          on: {
            "click": _vm.fncUpdatePodStatus
          }
        }) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          attrs: {
            "width": "5%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncRemoveFile(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_c('v-checkbox', {
          staticStyle: {
            "display": "inline-block"
          },
          on: {
            "change": function($event) {
              return _vm.fncMarkPaid(props.item)
            }
          },
          model: {
            value: (props.item.is_paid),
            callback: function($$v) {
              _vm.$set(props.item, "is_paid", $$v)
            },
            expression: "props.item.is_paid"
          }
        })], 1)])]
      }
    }], null, false, 1749300391)
  }) : _vm._e()], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('p', [_vm._v("These are attachments that were loaded to the Quote.")]), _c('br'), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.qHeaders,
      "items": _vm.globalModalParams.quoteAttachments,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "50%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncOpenFile(props.item.path)
            }
          }
        }, [_vm._v(_vm._s(props.item.original_filename))])]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "50%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncOpenFile(props.item.path)
            }
          }
        }, [_vm._v(_vm._s(props.item.created_timestamp))])])]
      }
    }], null, false, 289835855)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.globalModalParams && _vm.globalModalParams.quoteAttachments && _vm.globalModalParams.quoteAttachments.length <= 0 && _vm.showMeta == false) ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg12": ""
    }
  }, [_c('p', {
    staticClass: "smalltext"
  }, [_c('b', [_vm._v("Maximum file size allowed:")]), _vm._v(" " + _vm._s(_vm.objAuthorize.max_upload_size) + "MB")]), _vm._v(" "), _c('p', {
    staticClass: "smalltext"
  }, [_c('b', [_vm._v("File types supported:")]), _vm._v(" " + _vm._s(_vm.objAuthorize.allowed_file_types))]), _c('br'), _c('br'), _vm._v(" "), _c('input', {
    staticClass: "fileUpload",
    attrs: {
      "type": "file",
      "id": "quoteFile"
    },
    on: {
      "change": _vm.fncSetImageObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fileHolder"
  }, [_c('p', [_vm._v("Drag & Drop / Click to Add Files")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.fileName))])]), _vm._v(" "), (_vm.objSoSettings.length == 0) ? _c('small', {
    staticClass: "pt-4 pb-4"
  }, [_vm._v("No attachments has been uploaded to this sales order")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.objSoSettings.length != 0) ? _c('v-data-table', {
    staticClass: "elevation-1 overflow-x-auto",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.objSoSettings,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          attrs: {
            "width": "25%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncOpenFile(props.item.path)
            }
          }
        }, [_vm._v(_vm._s(props.item.original_filename))]), _vm._v(" "), (_vm.fncCanUpdatePod(props.item) && props.item.meta_data != null) ? _c('div', {
          staticStyle: {
            "margin-top": "10px",
            "text-indent": "5px"
          }
        }, [_c('b', [_vm._v("Delivery signed and Received by:")]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Name:")]), _vm._v(" " + _vm._s(JSON.parse(props.item.meta_data).name) + " " + _vm._s(JSON.parse(props.item.meta_data).surname))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("ID No:")]), _vm._v(" " + _vm._s(JSON.parse(props.item.meta_data).idNo))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Location:")]), _vm._v(" " + _vm._s(JSON.parse(props.item.meta_data).location))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Employer:")]), _vm._v(" " + _vm._s(JSON.parse(props.item.meta_data).employer))])]) : _vm._e()]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(_vm.fncFormatDate(props.item.created_timestamp)))]), _vm._v(" "), (_vm.attachmentCategories.length > 1) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "20%"
          }
        }, [_c('v-select', {
          staticClass: "dropdown",
          attrs: {
            "items": _vm.attachmentCategories,
            "label": "Attachment Category",
            "item-value": "id",
            "item-text": "name",
            "solo": "",
            "single-line": ""
          },
          on: {
            "input": function($event) {
              return _vm.fncSaveAttachmentCategory(props.item.id, props.item)
            }
          },
          model: {
            value: (props.item.category),
            callback: function($$v) {
              _vm.$set(props.item, "category", $$v)
            },
            expression: "props.item.category"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "30%"
          }
        }, [_c('div', {
          staticStyle: {
            "margin-top": "10px",
            "font-size": "12px !important",
            "display": "flex",
            "justify-content": "space-between"
          }
        }, [(_vm.fncCanUpdatePod(props.item)) ? _c('v-btn', {
          style: (_vm.getStyle()),
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.fncShowMeta(props.item.id, props.item.meta_data)
            }
          }
        }, [_vm._v("UPDATE ORDER RECIPIENT DETAILS")]) : _vm._e(), _vm._v(" "), (_vm.fncCanUpdatePod(props.item) && _vm.globalModalParams && _vm.globalModalParams.fullQuote.status !== 'POD Uploaded') ? _c('v-btn', {
          staticStyle: {
            "width": "48%"
          },
          attrs: {
            "color": "info"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.fncCheckPodStatus())
          },
          on: {
            "click": _vm.fncUpdatePodStatus
          }
        }) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "5%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncRemoveFile(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_c('v-checkbox', {
          staticStyle: {
            "display": "inline-block"
          },
          on: {
            "change": function($event) {
              return _vm.fncMarkPaid(props.item)
            }
          },
          model: {
            value: (props.item.is_paid),
            callback: function($$v) {
              _vm.$set(props.item, "is_paid", $$v)
            },
            expression: "props.item.is_paid"
          }
        })], 1)])]
      }
    }], null, false, 104725543)
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Save and Close")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}